// A base action with no payload.
export interface Action<T extends string> {
  type: T;
}

// An action with a payload.
export interface ActionWithPayload<T extends string, P> extends Action<T> {
  payload: P;
}

// This function creates an action either with a payload or not and retains it's
// type information
export function createAction<T extends string>(type: T): Action<T>;
export function createAction<T extends string, P>(
  type: T,
  payload: P
): ActionWithPayload<T, P>;
export function createAction<T extends string, P>(type: T, payload?: P) {
  return payload === undefined
    ? ({ type } as const)
    : ({ type, payload } as const);
}

type FunctionType = (...args: any[]) => any;

// This is the type of where we define our actions.
type ActionCreatorsMapObject = { [actionCreator: string]: FunctionType };

// This extracts the action types from the map of action creator functions.
export type ActionsUnion<A extends ActionCreatorsMapObject> = ReturnType<
  A[keyof A]
>;

export type Maybe<T> = T | null;

// Extract type from inside a promise.
type ThenArg<T> = T extends Promise<infer U> ? U : T;
// Now take that value from the return of a function
export type ReturnThen<T extends (...args: any) => any> = ThenArg<
  ReturnType<T>
>;

type AllKeyOf<T> = T extends never ? never : keyof T;

type Optional<T, K> = { [P in Extract<keyof T, K>]?: T[P] };

export type WithOptional<T, K extends AllKeyOf<T>> = T extends never
  ? never
  : Omit<T, K> & Optional<T, K>;

// extract type from Array
export type Unpacked<T> = T extends (infer U)[] ? U : T;

export type GraphqlError = {
  extensions: {
    code: string;
  };
};
